import React, { Component } from 'react';
import './tenant_application.css';

import DefaultApplicationForm from './default/ApplicationForm';
import ApplicationTemplateWizard from './application_templates/ApplicationTemplateWizard';
import StudentApplicationForm from './student/ApplicationForm';

import { connect } from 'react-redux';
import * as tenantApplicationActions from 'actions/tenantApplicationActions';
import { explosionCelebration } from 'actions/notificationActions';
import { getUserPreferences } from 'actions/userTypesActions';
import { getTenancyStatus } from 'actions/dashboardActions';

import { CSSTransitionGroup } from 'react-transition-group';

import { browserHistory } from 'react-router';

import { BounceLoader } from 'halogenium';

import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';
import { deepDiver } from 'helpers/utilities';
import { featureEnabled } from 'helpers/ToggleBot';

import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';
import { STUDENT_APPLICATION_TYPES } from 'constants/tenantApplication.constants';

let TenantApplication = connect(
  (store) => {
    return {
      isSending: store.tenantApplication.isSending,
      tenantApplication: store.tenantApplication.tenantApplication,
      applicationAvailable: store.tenantApplication.applicationAvailable,
    };
  },
  { ...tenantApplicationActions, explosionCelebration, getUserPreferences, getTenancyStatus }
)(
  class WizardForm extends Component {
    componentDidMount() {
      const query = browserHistory.getCurrentLocation().query;
      this.props.getUserPreferences();
      if (query.property_id) {
        this.props.verifyProperty(query.property_id);
        this.props.getTenantApplication(
          query.application_id || null,
          query.property_id,
          query.renewal_id || null
        );
      }
      this.props.getTenancyStatus();
      this.applicationManagementFeatureEnabled = featureEnabled('application-management');
    }

    componentWillUnmount() {
      window.onbeforeunload = function () {
        return undefined;
      };
    }

    UNSAFE_componentWillMount() {
      this.applicationManagementFeatureEnabled = featureEnabled('application-management');
      window.onbeforeunload = function () {
        return false;
      };
    }

    isStudentApplication() {
      return STUDENT_APPLICATION_TYPES.includes(
        deepDiver(this.props, 'tenantApplication.application_type')
      );
    }

    renderApplicationWizard() {
      if (this.isStudentApplication()) {
        return <StudentApplicationForm />;
      } else if (this.applicationManagementFeatureEnabled) {
        return <ApplicationTemplateWizard />;
      } else {
        return <DefaultApplicationForm />;
      }
    }

    render() {
      return (
        <div
          className={`container ${
            this.applicationManagementFeatureEnabled
              ? 'application-template-container'
              : 'application-container'
          }`}
          style={{ height: '100%', overflow: 'auto', padding: '0 20px' }}
        >
          {this.props.isSending && (
            <div
              style={{
                position: 'relative',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: '500',
              }}
            >
              <p
                style={{
                  textAlign: 'center',
                  marginTop: '30px',
                  width: '60px',
                  margin: 'auto',
                }}
              >
                <BounceLoader color={AccentColor()} />
              </p>
              <p
                style={{
                  textAlign: 'center',
                  marginTop: '15px',
                  marginBottom: '15px',
                }}
              >
                Bear with us as we send your application.
              </p>
            </div>
          )}
          {!this.props.applicationAvailable && (
            <CSSTransitionGroup transitionName="fade_in" transitionAppear={true}>
              <div>
                <h3
                  style={{
                    textAlign: 'center',
                    fontSize: '30px',
                    margin: '60px 0 10px',
                  }}
                >
                  {' '}
                  Application no longer available{' '}
                </h3>
                <div className="row" style={{ textAlign: 'center' }}>
                  <div
                    style={{
                      margin: 'auto',
                    }}
                  >
                    <p style={{ textAlign: 'justify' }}>
                      You may be seeing this error if you are filling out this application form from
                      the same computer as your co-applicant, or if you are using an old application
                      link. Make sure to log out of their account before proceeding. Your prospect
                      portal may also have the most recent application link. You can view your
                      prospect portal by clicking the button below. For technical inquiries, please
                      email us at help@yuhu.io.
                    </p>
                    <FlatButton
                      label="Return to Portal"
                      primary
                      style={{ color: 'white', backgroundColor: colors.RED }}
                      onClick={() => browserHistory.push('/dashboard')}
                    />
                  </div>
                </div>
              </div>
            </CSSTransitionGroup>
          )}
          {!this.props.isSending && this.props.applicationAvailable && (
            <CSSTransitionGroup
              transitionName="fade_out"
              transitionEnterTimeout={200}
              transitionAppear={true}
              transitionAppearTimeout={500}
              transitionLeaveTimeout={200}
            >
              {this.renderApplicationWizard()}
            </CSSTransitionGroup>
          )}
        </div>
      );
    }
  }
);

export default withMobileDialog()(TenantApplication);
